/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-return-assign */
import React from 'react';
import ReactDOM from 'react-dom';
import { styled } from 'twin.macro';

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    font-size: 22px;
    color: #7687c2;
    font-weight: 700;
    font-family: 'Arial Regular', Arial, sans-serif;
  }
`;

const ModalBody = styled.div`
  font-family: 'Arial Regular', Arial, sans-serif;
  margin-top: 30px;
  .line-header {
    font-size: 13px;
    color: #333333;
  }
  .copy {
    font-family: 'Arial Bold', Arial, sans-serif;
    font-size: 24px;
    color: #333333;
    font-weight: 400;
    margin-top: 8px;
    line-height: 33px;
  }
  .download-button {
    width: 97px;
    height: 40px;
    border-radius: 5px;
    background-color: #6e0b8a;
    color: #ffffff;
    text-align: center;
    font-size: 13px;
  }
`;

const ActivitiesModal = ({ selectedActivity }) => {
  const handleDownload = (fileUrl) => {
    const link = document.createElement('a');
    link.href = `https://assets.sparkyard.com/${fileUrl}`;
    link.download = fileUrl.split('/').pop();
    // console.log(link.download);
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const modalContent = (
    <div
      className="modal fade"
      id="wonder-activity-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="wonder-information-modal"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div
            className="custom__modal__content"
            style={{ borderRadius: '10px', border: '2px solid #7687c2' }}
          >
            <ModalHeader>
              <h1>{selectedActivity?.headline}</h1>
              <a href="" className="custom__modal__close" data-dismiss="modal">
                <img src="/img/plus-icon.svg" alt="" />
              </a>
            </ModalHeader>
            <ModalBody>
              <div
                dangerouslySetInnerHTML={{
                  __html: selectedActivity?.copy,
                }}
                className="copy"
              />
              {selectedActivity?.files?.map((file) => (
                <button
                  key={file}
                  className="download-button"
                  onClick={() => handleDownload(file.attributes.file)}
                  type="button"
                >
                  Download
                </button>
              ))}
            </ModalBody>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ActivitiesModal;
